import { Component } from '@angular/core';

@Component({
  selector: 'app-loader-global',
  imports: [],
  template: `
    <div class="loader-global">
      <span class="loader"></span>
    </div>
  `
})
export class LoaderGlobal {}
